import { Component, h, Prop, Event, EventEmitter, Fragment } from '@stencil/core'
import { modalController } from '@ionic/core';
import { DateUtils, TaskDoc } from 'common';

@Component({
  tag: 'task-info-modal',
})
export class TaskInfoModal {
  static async presentModal(task: TaskDoc): Promise<void> {
    const modal = await modalController.create({
      component: 'task-info-modal',
      cssClass: 'concourse-modal modal-height-auto',
      componentProps: { task }
    });

    modal.addEventListener('dismiss', () => {
      modal.dismiss();
    });

    return await modal.present();
  }

  @Prop() task: TaskDoc;
  @Event() dismiss: EventEmitter;

  get startDateFormatted(): string {
    const startDate = this.task.actual_start || this.task.start || this.task.planned_start;
    return startDate ? DateUtils.format(DateUtils.fromISO(startDate)) : '';
  }
  get endDateFormatted(): string {
    const endDate = this.task.actual_finish || this.task.finish || this.task.planned_finish;
    return endDate ? DateUtils.format(DateUtils.fromISO(endDate)) : '';
  }
  get durationFormatted(): string {
    const duration = this.task.actual_duration || this.task.duration || this.task.scheduled_duration || 0;
    return DateUtils.secondsToPeriod(duration);
  }

  render() {
    return (
      <Fragment>
        <ion-header>
          <ion-toolbar>
            <ion-title>{this.task.name}</ion-title>
            <ion-buttons slot="end">
              <ion-button onClick={() => this.dismiss.emit()}>
                <ion-icon slot="icon-only" name="close"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-page class="ion-padding">
          <div class="small-super-script">start</div>
          <p title={this.task.start}>{this.startDateFormatted}</p>
          <div class="small-super-script">end</div>
          <p title={this.task.finish}>{this.endDateFormatted}</p>
          <div class="small-super-script">duration</div>
          <p title={`${this.task.duration}`}>{this.durationFormatted}</p>
        </ion-page>
      </Fragment>
    )
  }
}
